var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18335",
    className: "icon",
    "data-name": "Group 18335",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.879,
    height: 21.818,
    viewBox: "0 0 21.879 21.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17010",
    "data-name": "Rectangle 17010",
    width: 21.879,
    height: 21.818,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18335-2",
    "data-name": "Group 18335",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20262",
    "data-name": "Path 20262",
    d: "M16.251,17.766A47.927,47.927,0,0,0,12.327,13.9a6.188,6.188,0,0,1-2.48-6.029A47.823,47.823,0,0,0,9.87,2.5a2.009,2.009,0,0,0-.145-.359c-1.028.4-2.07.786-3.093,1.217a5.555,5.555,0,0,0-.924.6c-.723.5-1.338.46-1.729-.1s-.237-1.143.479-1.675A10.9,10.9,0,1,1,11.19,21.816a10.343,10.343,0,0,1-9.78-5.683,10.473,10.473,0,0,1,.527-11.3c.506-.792,1.119-.971,1.7-.56.544.386.583,1,.11,1.741a8.738,8.738,0,0,0,5.582,13.5,8.3,8.3,0,0,0,6.924-1.743M19.523,9.8c.03-3.472-4.33-7.782-7.383-7.4V9.8Zm.066,2.253H13.845l4.112,4.113a7.934,7.934,0,0,0,1.632-4.113",
    transform: "translate(0 0)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.98adf89561f9e681ada2fc3799948898.svg";
export { ForwardRef as ReactComponent };